
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9d6BC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e187a8d32c4ec8a5$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $jpMnG = parcelRequire("jpMnG");


var $6mbqi = parcelRequire("6mbqi");


var $i4o81 = parcelRequire("i4o81");


var $grxv4 = parcelRequire("grxv4");

var $3rvSa = parcelRequire("3rvSa");


var $kZmsK = parcelRequire("kZmsK");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $5l1kQ = parcelRequire("5l1kQ");


var $inPa6 = parcelRequire("inPa6");


var $fZRom = parcelRequire("fZRom");


var $gi5bC = parcelRequire("gi5bC");


var $d925B = parcelRequire("d925B");

const $e187a8d32c4ec8a5$var$RenderMediaInline = ({ rendererAppearance: rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $42omo.useState)();
    const [fileState, setFileState] = (0, $42omo.useState)();
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    const contextIdentifierProvider = (0, $6mbqi.useProvider)('contextIdentifierProvider');
    (0, $42omo.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $42omo.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $42omo.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $5l1kQ.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $5l1kQ.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $5l1kQ.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $42omo.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
   * Only show the loading view if the media client is not ready
   * prevents calling the media API before the provider is ready
   */ if (!mediaClient) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kZmsK.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...(0, $5l1kQ.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i4o81.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $5l1kQ.mediaIdentifierMap).values())
        })
    }));
};
const $e187a8d32c4ec8a5$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fZRom.ErrorBoundary), {
            component: (0, $gi5bC.ACTION_SUBJECT).RENDERER,
            componentId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jpMnG.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $grxv4.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($e187a8d32c4ec8a5$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $e187a8d32c4ec8a5$export$2e2bcd8739ae039 = (0, $gmMgo.default)($e187a8d32c4ec8a5$var$MediaInline);

});

parcelRegister("5l1kQ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lcuos = parcelRequire("lcuos");


var $dh538 = parcelRequire("dh538");


var $1BiXn = parcelRequire("1BiXn");

var $lasm3 = parcelRequire("lasm3");

var $9s7Po = parcelRequire("9s7Po");

var $8yFQr = parcelRequire("8yFQr");


var $3rvSa = parcelRequire("3rvSa");


var $8Doca = parcelRequire("8Doca");


var $1oCLl = parcelRequire("1oCLl");


var $6uN0A = parcelRequire("6uN0A");


var $d925B = parcelRequire("d925B");

const $c97c7f2b7cd82c79$export$7da2d00ddd5627a6 = new Map();
const $c97c7f2b7cd82c79$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $lcuos.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $c97c7f2b7cd82c79$export$cfff5eb155a82d30 extends (0, $42omo.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.has(id) || url && $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $c97c7f2b7cd82c79$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        const Card = enableSyncMediaCard && (0, $dh538.fg)('jfp-magma-ssr-iv-editor-media') ? (0, $8yFQr.default) : (0, $1BiXn.default);
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Card, {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($c97c7f2b7cd82c79$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false,
                onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $l998X.jsx)((0, $lasm3.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        const Card = enableSyncMediaCard && (0, $dh538.fg)('jfp-magma-ssr-iv-editor-media') ? (0, $8yFQr.default) : (0, $1BiXn.default);
        // Quick solution to disable lazy loading of images on PDF export pages in Confluence to remedy an issue with images never loading
        // More robust solution will be implemented as part of CCPDF-233 - Link: https://hello.jira.atlassian.cloud/browse/CCPDF-233
        const currentUrl = window.location.href;
        const shouldDisableLazyLoading = (0, $1oCLl.expValEquals)('platform_editor_disable_lazy_load_media', 'isEnabled', true) && currentUrl.includes('/wiki/pdf/spaces/');
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...$c97c7f2b7cd82c79$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Card, {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile && !shouldDisableLazyLoading,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($c97c7f2b7cd82c79$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile,
                onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {};
        this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        };
        this.onError = (reason)=>{
            this.props.fireAnalyticsEvent?.({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    reason: reason,
                    external: false
                }
            });
        };
        this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9s7Po.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        };
        /**
     * We want to call provided `eventHandlers.media.onClick` when it's provided,
     * but we also don't want to call it when it's a video and inline video player is enabled.
     * This is due to consumers normally process this onClick call by opening media viewer and
     * we don't want that to happened described above text.
     */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $c97c7f2b7cd82c79$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $c97c7f2b7cd82c79$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uN0A.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($c97c7f2b7cd82c79$export$cfff5eb155a82d30, {
                ...props,
                mediaClient: mediaClient,
                fireAnalyticsEvent: fireAnalyticsEvent
            });
        }
    });
};
const $c97c7f2b7cd82c79$export$a6543a2e3828db2c = (0, $8Doca.withImageLoader)($c97c7f2b7cd82c79$export$fae4803d1ca121c8);
module.exports["mediaIdentifierMap"] = $c97c7f2b7cd82c79$export$7da2d00ddd5627a6;
module.exports["getClipboardAttrs"] = $c97c7f2b7cd82c79$export$92bef806f5be5d7c;
module.exports["MediaCard"] = $c97c7f2b7cd82c79$export$a6543a2e3828db2c;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("lasm3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gUYJl = parcelRequire("gUYJl");


var $64ehG = parcelRequire("64ehG");


var $fDGbV = parcelRequire("fDGbV");

class $4d827ca5540b7b64$export$f7f7efdefcc02999 extends (0, $42omo.Component) {
    render() {
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            dimensions: dimensions
        }, this.icon);
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gUYJl.ErrorIcon), {
            size: size
        });
    }
}
$4d827ca5540b7b64$export$f7f7efdefcc02999.defaultProps = {
    size: 'medium'
};
module.exports["CardError"] = $4d827ca5540b7b64$export$f7f7efdefcc02999;

});

parcelRegister("gUYJl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $kCWfQ = parcelRequire("kCWfQ");


var $deU3H = parcelRequire("deU3H");

class $cc3567b97db2e0fc$export$19bc16ee58e19b3d extends (0, $42omo.Component) {
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $deU3H.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kCWfQ))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}
$cc3567b97db2e0fc$export$19bc16ee58e19b3d.defaultProps = {
    size: 'small'
};
module.exports["ErrorIcon"] = $cc3567b97db2e0fc$export$19bc16ee58e19b3d;

});

parcelRegister("deU3H", function(module, exports) {
function $1a717317aba342a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a717317aba342a5$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};
module.exports["errorIconWrapperStyles"] = $1a717317aba342a5$export$8dcf6b831a37de79;

});

parcelRegister("8yFQr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $r0CCR = parcelRequire("r0CCR");

const $fae0b8a709d3e7ba$var$CardSync = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card-sync",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $r0CCR.CardWithMediaClient), props));
};
var $fae0b8a709d3e7ba$export$2e2bcd8739ae039 = $fae0b8a709d3e7ba$var$CardSync;
module.exports["default"] = $fae0b8a709d3e7ba$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #44546F)" : "var(--ds-icon-accent-blue, #1D7AFC)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #44546F)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("8DZd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64b1721c286de662$var$_react = $64b1721c286de662$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $64b1721c286de662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b1721c286de662$var$Generic16Icon = (props)=>/*#__PURE__*/ $64b1721c286de662$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64b1721c286de662$var$Generic16Icon.displayName = 'Generic16Icon';
var $64b1721c286de662$var$_default = module.exports.default = $64b1721c286de662$var$Generic16Icon;

});

parcelRegister("djgQ6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b0a1cae716cd1ca$var$_react = $9b0a1cae716cd1ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9b0a1cae716cd1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b0a1cae716cd1ca$var$Generic24Icon = (props)=>/*#__PURE__*/ $9b0a1cae716cd1ca$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9b0a1cae716cd1ca$var$Generic24Icon.displayName = 'Generic24Icon';
var $9b0a1cae716cd1ca$var$_default = module.exports.default = $9b0a1cae716cd1ca$var$Generic24Icon;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});


//# sourceMappingURL=mediaInline.8166bd2e.js.map
